import { UseFormRegisterReturn } from 'react-hook-form';
import { ChangeEvent, ReactNode } from 'react';
import { IconMinus } from '@/features/icons';
import { IconTick } from '@/components/svg-symbols/icons';
import { cn } from '@/utils/cn';
interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  children: ReactNode;
  checkboxSize: 'large' | 'medium';
  disabled?: boolean;
  isSelectedAll?: boolean;
  registeredField?: UseFormRegisterReturn;
  customOnChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
}
export function Checkbox({
  id,
  checkboxSize,
  registeredField,
  customOnChange,
  children,
  disabled = false,
  isSelectedAll = false,
  checked,
  className
}: Props) {
  const onChange = registeredField?.onChange;
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(e);
    customOnChange && customOnChange(e);
  };
  return <label htmlFor={id} className={cn('flex w-fit grow items-center gap-2', {
    'cursor-pointer': !disabled,
    'cursor-default': disabled,
    'p-px': checkboxSize === 'large'
  }, className)} data-sentry-component="Checkbox" data-sentry-source-file="checkbox.tsx">
            <div className={cn('relative flex items-center justify-center p-px', {
      'h-5.5 w-5.5 min-w-[22px]': checkboxSize === 'large',
      'h-5 w-5 min-w-[20px]': checkboxSize !== 'large'
    })}>
                <input {...checked !== undefined ? {
        checked: checked
      } : {}} type='checkbox' id={id} className={cn('peer/checkbox h-full w-full cursor-pointer appearance-none rounded-md border-text-mediumGray outline-none transition-all checked:border-primary-main enabled:hover:border-text-darkGray enabled:checked:hover:border-primary-shade-400 disabled:cursor-default disabled:border-text-lightGray disabled:checked:border-primary-shade-200 peer-checked/checkbox:hidden', {
        '!border-primary-main hover:!border-primary-shade-400 disabled:!border-primary-shade-800': isSelectedAll,
        'border-2': checkboxSize === 'large',
        border: checkboxSize !== 'large'
      })} {...registeredField} onChange={handleChange} disabled={disabled} />

                {!isSelectedAll && <IconTick className={cn('absolute hidden text-primary-main transition-all hover:text-primary-shade-400 peer-checked/checkbox:flex peer-disabled/checkbox:text-primary-shade-200', {
        'h-6 w-6': checkboxSize === 'large',
        'h-5 w-5': checkboxSize !== 'large'
      })} />}
                {isSelectedAll && <IconMinus className={cn('absolute text-primary-main transition-all peer-hover/checkbox:text-primary-shade-400 peer-disabled/checkbox:text-primary-shade-800', {
        'h-4 w-4': checkboxSize === 'large',
        'h-3 w-3': checkboxSize !== 'large'
      })} />}
            </div>

            {typeof children === 'string' ? <span className='text-body-14 text-text-black lg:text-body-16'>{children}</span> : children}
        </label>;
}